import moment from 'moment';

// Started today or earlier, ends today or later. Compared by day, not timestamp: the dates parse to
// midnight while "now" carries a time, which reads a period ending today as already over.
const isCurrentContract = ({ start_date, end_date }) => {
  const today = moment();
  return moment(start_date).isSameOrBefore(today, 'day') && moment(end_date).isSameOrAfter(today, 'day');
};

// Newest first — call sites take `formattedData[0]` as the default selection. Current before end_date, since
// a period that has not started yet ends later than the one running today. start_date only breaks ties.
const byRecency = (a, b) => (
  (isCurrentContract(b) - isCurrentContract(a))
  || Date.parse(b.end_date) - Date.parse(a.end_date)
  || Date.parse(b.start_date) - Date.parse(a.start_date)
);

class ContractsManager {
  constructor(data, type) {
    this.data = data.sort(byRecency);
    this.type = type;
    this.formattedData = this.formatData();
  }

  formatData = () => {
    var list = [];
    let yearstrs = [];
    list = list.concat(this.data).map((contract) => {
      const currentDate = Date.parse(new Date());
      const end_date = Date.parse(contract.end_date);

      let text = '';
      // Same rule as the ordering, so the default selection is the period labelled Current.
      if (isCurrentContract(contract) && !yearstrs.some(v => v.includes('Current')) ) {
        text = `Current (${moment(contract.start_date).format("MMM ‘YY") + ' - ' + moment(contract.end_date).format("MMM ‘YY")})`;
      } else if (
        currentDate > end_date &&
        (currentDate - end_date) / (1000 * 3600 * 24) < 366 &&
        !yearstrs.some(v => v.includes('Previous'))
      ) {
        text = `Previous (${moment(contract.start_date).format("MMM ‘YY") + ' - ' + moment(contract.end_date).format("MMM ‘YY")})`;
      } else {
        text = moment(contract.start_date).format("MMM ‘YY") + ' - ' + moment(contract.end_date).format("MMM ‘YY");
      }
      yearstrs.push(text);
      return {
        text,
        contract_id: contract.id,
        is_running_contract: text.includes('Current'),
        is_overall_contract: false,
        total_customers: contract.total_customers,
        start_date: contract.start_date,
        end_date: contract.end_date,
        enable_health_checks: contract.enable_health_checks,
        enable_doctor_consultations: contract.enable_doctor_consultations,
        enable_pharmacy: contract.enable_pharmacy,
        enable_gym: contract.enable_gym,
        enable_vaccination: contract.enable_vaccination,
        enable_health_coach: contract.enable_health_coach,
        enable_hra: contract.enable_hra,
        enable_spending_account: contract.enable_spending_account,
        remote_wallet_enabled: contract.remote_wallet_enabled,
        showSpendingOrRemoteWallet: !!(contract.enable_spending_account || contract.remote_wallet_enabled),
        total_registered_customers: contract.total_registered_customers,
        enable_dental_checks: contract.enable_dental_checks,
        enable_vision_checks: contract.enable_vision_checks
      };
    });

    // "Overall" spans every period, so it needs the real extremes. Neither end of the list gives them: the
    // order puts the current period first, and the earliest start is not the last entry once periods overlap.
    const earliestBy = (key) => list.reduce((found, c) => (Date.parse(c[key]) < Date.parse(found) ? c[key] : found), list[0][key])
    const latestBy = (key) => list.reduce((found, c) => (Date.parse(c[key]) > Date.parse(found) ? c[key] : found), list[0][key])
    const startDate = list.length > 0 ? earliestBy('start_date') : ''
    const endDate = list.length > 0 ? latestBy('end_date') : ''

    if (['HEALTH_CHECKS', 'DOCTOR_CONSULTATION', 'DENTAL', 'VISION', 'VACCINATION'].includes(this.type) && list.length > 1) list.push({ text: 'Overall', start_date: startDate, end_date: endDate, is_overall_contract: true })
    return list;
  };
}

export default ContractsManager;
